import React from 'react';

export const SubscriptionPreview = React.lazy(() => import('./SubscriptionPreview'));
